import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `PanelsDirective` represent a presets of the react dashboardlayout.
 * It must be contained in a dashboardlayout component(`DashBoardLayoutComponent`).
 * ```tsx
 * <DashBoardLayoutComponent>
 * <PanelsDirective>
 * <PanelDirective></PanelDirective>
 * <PanelDirective></PanelDirective>
 * </PanelsDirective>
 * </DashBoardLayoutComponent>
 * ```
 */
export class PanelDirective extends ComplexBase {
}
PanelDirective.moduleName = 'panel';
PanelDirective.complexTemplate = { 'panels.header': 'panels.header', 'panels.content': 'panels.content' };
export class PanelsDirective extends ComplexBase {
}
PanelsDirective.propertyName = 'panels';
PanelsDirective.moduleName = 'panels';
